import * as t from "io-ts";
import * as tPromise from "io-ts-promise";
import { createCargoTypes, isoDateTime } from "dora-contracts";
import { CargoFormDataBase } from "../cargo-and-template-shared";

export const {
  editCargoInputT,
  editCargoOutputT,
  editStopOutputT,
  stopT,
  postCargoWithEquipmentT,
  postCargoWithInvoiceLinesAndEquipmentT,
  createCargoOnDriverRoutesReqT,
  stopUnitT,
} = createCargoTypes({
  decimal: t.string,
  date: t.string,
  dateTime: isoDateTime,
});

export const cargosT = t.array(editCargoOutputT);
export const decodeCargo = tPromise.decode(editCargoOutputT);
export type StopApi = t.TypeOf<typeof stopT>;
export type StopUnitApi = t.TypeOf<typeof stopUnitT>;
export type Stop2 = t.TypeOf<typeof editStopOutputT>;

export interface CargoFormData extends CargoFormDataBase {
  ref?: string;
}

export interface CargoFormDataWithClientId extends CargoFormDataBase {
  clientId: string;
}

export interface CargoData extends CargoFormData {
  id?: string; // cargo id
  userId?: string | null; // created by dispatcher id
  createdAt?: string; // created date
  deliveryId?: string;
  canBeDeleted?: boolean;
  invoiceStatusLocked?: boolean;
  route_id?: string;
  // Set only when creating a cargo from a client cargo template - see
  // CreateEditShipmentDialog's submit(). Never sent/changed on update.
  clientCargoTemplateId?: string | null;
  // The distance the server stored for the saved stops - see
  // CreateEditShipmentDialog's estimated distance. Never sent on save.
  distanceKm?: string | null;
}
